import styled from "styled-components";
import { BTTO_PROFILE_COLORS, bettoFocusRing } from "../../shared/elements";

export const SidebarRoot = styled.nav`
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 100%;
	padding: 12px;
	border-radius: 12px;
	background: ${BTTO_PROFILE_COLORS.surface};
	border: 1px solid ${BTTO_PROFILE_COLORS.border};

	@media (max-width: 1023px) {
		flex-direction: row;
		overflow-x: auto;
		padding: 8px;
		gap: 6px;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}
`;

export const SidebarItem = styled.button`
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	padding: 10px 12px;
	border: 1px solid transparent;
	border-radius: 8px;
	background: ${({ $active }) => ($active ? BTTO_PROFILE_COLORS.surfaceRaised : "transparent")};
	color: ${({ $active }) => ($active ? BTTO_PROFILE_COLORS.text : BTTO_PROFILE_COLORS.textMuted)};
	font-size: 13px;
	font-weight: ${({ $active }) => ($active ? 600 : 500)};
	line-height: 1.3;
	text-align: left;
	cursor: pointer;
	white-space: nowrap;
	transition:
		background 0.2s ease,
		border-color 0.2s ease,
		color 0.2s ease;
	${bettoFocusRing}

	${({ $active }) =>
		$active &&
		`
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
	`}

	&:hover {
		background: ${BTTO_PROFILE_COLORS.surfaceRaised};
		color: ${BTTO_PROFILE_COLORS.text};
	}

	@media (max-width: 1023px) {
		width: auto;
		flex-shrink: 0;
	}
`;

export const SidebarIcon = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 20px;
	height: 20px;

	svg {
		width: 18px;
		height: 18px;
	}
`;

export const SidebarBadge = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	margin-left: auto;
	border-radius: 50%;
	background: ${BTTO_PROFILE_COLORS.warning};
	color: #fff;
	font-size: 10px;
	font-weight: 700;
	line-height: 1;

	@media (max-width: 1023px) {
		margin-left: 4px;
	}
`;

export const SidebarLabel = styled.span`
	flex: 1;
	min-width: 0;
`;
